// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { UserTypeParentDto, LoggedInDto, WebAccountDto, UserTypeDto, ResultDataOfNullableGuid, WebJobTypeDto } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useWebAccountsResource () {

    /**
     * Get the currently logged in web account if we have one
     * @return The logged in web account or NULL
     */
    function loggedInWebAccount(
        
    ) : UseApiFetchResponse<LoggedInDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/me";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<LoggedInDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<LoggedInDto>( computedUrl, options_ );
    }


    /**
     * Get the currently logged-in users web user type from the cache
     * @return A web user type or 401 is we are not logged in
     */
    function loggedInUserType(
        
    ) : UseApiFetchResponse<UserTypeDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/me/user-type";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<UserTypeDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<UserTypeDto>( computedUrl, options_ );
    }

    /**
     * Get the currently logged-in users web user type parent from the cache
     * @return A web user type parent  or 401 is we are not logged in
     */
    function loggedInUserTypeParent(
        
    ) : UseApiFetchResponse<UserTypeParentDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/me/user-type-parent";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<UserTypeParentDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<UserTypeParentDto>( computedUrl, options_ );
    }

    /**
     * Retrieves a list of web user types
     * @return A list of web user types
     */
    function getWebUserTypes(
        
    ) : UseApiFetchResponse<UserTypeDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/web-user-types";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<UserTypeDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<UserTypeDto[]>( computedUrl, options_ );
    }

    /**
     * Retrieves a list of web user type parents
     * @return A list of web user type parents
     */
    function getWebUserTypeParents(
        
    ) : UseApiFetchResponse<UserTypeParentDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/web-user-types/parents";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<UserTypeParentDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<UserTypeParentDto[]>( computedUrl, options_ );
    }


    /**
     * Retrieves a list of web user job types for a web user type parent
     * @param webUserTypeParentId The ID of the web user type parent to retrieve job types for
     * @return A list of web user job types
     */
    function getParentJobTypes(
        webUserTypeParentId: MaybeRef<number>
    ) : UseApiFetchResponse<WebJobTypeDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/web-user-types/parents/{webUserTypeParentId}/job-types";

        const webUserTypeParentIdUnref = unref( webUserTypeParentId );
        if (webUserTypeParentIdUnref === undefined || webUserTypeParentIdUnref === null)
            throw new Error("The parameter 'webUserTypeParentId' must be defined.");
        url_ = url_.replace("{webUserTypeParentId}", encodeURIComponent("" + webUserTypeParentIdUnref));

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<WebJobTypeDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<WebJobTypeDto[]>( computedUrl, options_ );
    }

    /**
     * Check to see if the email address is already registered
     * @param emailAddress (optional) The email address to check
     * @param ignoreGuests (optional) Should we ignore guest web accounts when checking
     * @return True if all ready registered
     */
    function checkEmailEmailAddress(
        emailAddress?: MaybeRef<string | undefined>,
        ignoreGuests?: MaybeRef<boolean | null | undefined>
    ) : UseApiFetchResponse<boolean> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/check-email-address?";

        const emailAddressUnref = unref( emailAddress );
        if (emailAddressUnref === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddressUnref !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddressUnref) + "&";
        const ignoreGuestsUnref = unref( ignoreGuests );
        if (ignoreGuestsUnref !== undefined && ignoreGuestsUnref !== null)
            url_ += "ignoreGuests=" + encodeURIComponent("" + ignoreGuestsUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<boolean> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<boolean>( computedUrl, options_ );
    }

    /**
     * Get a list of children for the current web account
     * @return A list of child web accounts
     */
    function getChildren(
        
    ) : UseApiFetchResponse<WebAccountDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/web-accounts/children";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<WebAccountDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<WebAccountDto[]>( computedUrl, options_ );
    }

    return {
        loggedInWebAccount,
        loggedInUserType,
        loggedInUserTypeParent,
        getWebUserTypes,
        getWebUserTypeParents,
        getParentJobTypes,
        checkEmailEmailAddress,
        getChildren,
    }
}


export function $webAccountsResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Get the currently logged in web account if we have one
     * @return The logged in web account or NULL
     */
    function loggedInWebAccount(
        
    ) {
        let url_ = "/api/web-accounts/me";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<LoggedInDto>( url_, options_, dependencies_ );
    }

    /**
     * Updates an existing web account for the current user
     * @param modifiedWebAccountDto The web account data to save
     * @return The ID of the updated web account, or null if not updated
     */
    function updateUser(
        modifiedWebAccountDto: WebAccountDto
    ) {
        let url_ = "/api/web-accounts/me";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = modifiedWebAccountDto;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "PATCH",
        };

        return $apiFetch<string | null>( url_, options_, dependencies_ );
    }

    /**
     * Deletes the current user's web account
     */
    function closeAccount(
        
    ) {
        let url_ = "/api/web-accounts/me/delete";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<any>( url_, options_, dependencies_ );
    }

    /**
     * Get the currently logged-in users web user type from the cache
     * @return A web user type or 401 is we are not logged in
     */
    function loggedInUserType(
        
    ) {
        let url_ = "/api/web-accounts/me/user-type";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<UserTypeDto>( url_, options_, dependencies_ );
    }

    /**
     * Get the currently logged-in users web user type parent from the cache
     * @return A web user type parent  or 401 is we are not logged in
     */
    function loggedInUserTypeParent(
        
    ) {
        let url_ = "/api/web-accounts/me/user-type-parent";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<UserTypeParentDto>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves a list of web user types
     * @return A list of web user types
     */
    function getWebUserTypes(
        
    ) {
        let url_ = "/api/web-accounts/web-user-types";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<UserTypeDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves a list of web user type parents
     * @return A list of web user type parents
     */
    function getWebUserTypeParents(
        
    ) {
        let url_ = "/api/web-accounts/web-user-types/parents";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<UserTypeParentDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Saves the provided web account
     * @param webAccount The web account to save
     * @return The web account ID is successful, else null
     */
    function save(
        webAccount: WebAccountDto
    ) {
        let url_ = "/api/web-accounts";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = webAccount;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<ResultDataOfNullableGuid>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves a list of web user job types for a web user type parent
     * @param webUserTypeParentId The ID of the web user type parent to retrieve job types for
     * @return A list of web user job types
     */
    function getParentJobTypes(
        webUserTypeParentId: number
    ) {
        let url_ = "/api/web-accounts/web-user-types/parents/{webUserTypeParentId}/job-types";

        const webUserTypeParentIdUnref = unref( webUserTypeParentId );
        if (webUserTypeParentIdUnref === undefined || webUserTypeParentIdUnref === null)
            throw new Error("The parameter 'webUserTypeParentId' must be defined.");
        url_ = url_.replace("{webUserTypeParentId}", encodeURIComponent("" + webUserTypeParentIdUnref));

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<WebJobTypeDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Check to see if the email address is already registered
     * @param emailAddress (optional) The email address to check
     * @param ignoreGuests (optional) Should we ignore guest web accounts when checking
     * @return True if all ready registered
     */
    function checkEmailEmailAddress(
        emailAddress?: string | undefined,
        ignoreGuests?: boolean | null | undefined
    ) {
        let url_ = "/api/web-accounts/check-email-address?";

        const emailAddressUnref = unref( emailAddress );
        if (emailAddressUnref === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddressUnref !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddressUnref) + "&";
        const ignoreGuestsUnref = unref( ignoreGuests );
        if (ignoreGuestsUnref !== undefined && ignoreGuestsUnref !== null)
            url_ += "ignoreGuests=" + encodeURIComponent("" + ignoreGuestsUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Get a list of children for the current web account
     * @return A list of child web accounts
     */
    function getChildren(
        
    ) {
        let url_ = "/api/web-accounts/children";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<WebAccountDto[]>( url_, options_, dependencies_ );
    }

    return {
        loggedInWebAccount,
        updateUser,
        closeAccount,
        loggedInUserType,
        loggedInUserTypeParent,
        getWebUserTypes,
        getWebUserTypeParents,
        save,
        getParentJobTypes,
        checkEmailEmailAddress,
        getChildren,
    }
}